<template>
  <div class="md-layout text-center">
    <notifications></notifications>
    <div
      class="
        md-layout-item
        md-size-66
        md-medium-size-66
        md-small-size-90
        md-xsmall-size-100
      "
    >
      <!--  header-color="blue" -->
      <cdk-card :overflowhidden="true"> 
        <md-field class="md-form-group" slot="inputs">
          <md-icon>toggle_on</md-icon>
          <label>激活方式</label>
          <md-select v-model="active_type" type="" style="margin-left: 12px;">
            <md-option :value="1">单个激活</md-option>
            <md-option :value="2">批量激活</md-option>
          </md-select>
        </md-field>

        <md-field class="md-form-group" slot="inputs">
          <md-icon><icon-appid/></md-icon>
          <label>APPID</label>
          <md-input v-model="appid"></md-input>
        </md-field>
        <template v-if="active_type == 1">
          <md-field class="md-form-group" slot="inputs">
            <md-icon><icon-account/></md-icon>
            <label>账号</label>
            <md-input v-model="account" type=""></md-input>
          </md-field>
          <md-field class="md-form-group" slot="inputs">
            <md-icon><icon-uid/></md-icon>
            <label>UID</label>
            <md-input v-model="uid" type=""></md-input>
          </md-field>
          <md-field class="md-form-group" slot="inputs">
            <md-icon><icon-channel/></md-icon>
            <label>通道号</label>
            <md-input v-model="channel" type=""></md-input>
          </md-field>
          <md-field class="md-form-group" slot="inputs">
            <md-icon><icon-cdk/></md-icon>
            <label>激活码</label>
            <md-input v-model="cdk" type=""></md-input>
          </md-field>
        </template>
        <template v-else>
          <md-field class="md-form-group" slot="inputs">
            <md-icon>description</md-icon>
            <label>文件</label>
            <md-input readonly v-model="file_name" @click="modal_file_input" :placeholder="$I18n('click_select_file')" ></md-input>
            <input :style="{display:'none'}" type="file" ref="inputFile" @change="onChange"/>
          </md-field>
        </template>
        <md-field class="md-form-group" slot="inputs">
          <md-icon><icon-reset/></md-icon>
          <label>生效方式</label>
          <md-select v-model="start_type" type="" style="margin-left: 12px;">
            <md-option :value="1">立即生效</md-option>
            <md-option :value="2">顺延生效</md-option>
          </md-select>
        </md-field>
        <md-button slot="footer" class="diy-submit md-info md-round" @click="submit">
          激活
        </md-button>
        <md-button slot="footer" class="diy-submit md-round" @click="reset">
          重置
        </md-button>
        <!-- 记录 -->
          <md-button v-if="active_type != 1" class="diy-submit md-info md-round" slot="footer" href="/files/cdk.xlsx" download="modal.xlsx">
            {{$I18n("frame")}}
          </md-button>
        <!-- 记录 -->
        <md-button v-if="active_type != 1" slot="footer" class="diy-submit md-info md-round" @click="form_importTableModel">
          {{$I18n("dev_import")}}
        </md-button>
      </cdk-card>
    </div>
    <simple-modal ref="import" :title="$I18n('dev_import')" :right="true" :large="false" :submitBtn="false">
      <template slot="body">
        <!-- 弹窗-查询表单 -->
        <div class="md-layout">
          <!-- 选择栏-导入状态 {0: 全部, 1: 已导入, 2: 有错误, 3: 文件错误, 4: 待导入, 5: 正在导入}-->
          <div class="md-layout-item md-size-30 left-layout-item">
            <md-field>
              <label>{{$I18n("import_state")}}</label>
              <md-input v-model="form_id" :placeholder="'ID'"></md-input>
            </md-field>
          </div>
          <!-- 按钮-提交查询 -->
          <div class="md-layout-item left-btn">
            <md-button class= "left-icon md-info" @click="modal_changeSearchData">
              <md-icon>search</md-icon>
              {{$I18n("search")}}
            </md-button>
          </div>
        </div>
        <div class="md-layout" :style='{"color":"#000000","margin-bottom":"10px","padding":"20px 0","border-bottom":"1px solid #aaaaaa","font-size":"18px"}'>
          <div class="md-layout-item md-size-50" :style="{'margin-bottom':'20px'}">
            生效方式: {{modalTableData.start_type_name}}
          </div>
          <div class="md-layout-item md-size-50" :style="{'margin-bottom':'20px'}">
            状态: {{modalTableData.state_name}}
          </div>
          <div class="md-layout-item md-size-33">
            总数: {{modalTableData.mng_num ?modalTableData.mng_num :0}}
          </div>
          <div class="md-layout-item md-size-33">
            成功: {{modalTableData.suc_num ?modalTableData.suc_num :0}}
          </div>
          <div class="md-layout-item md-size-33">
            失败: {{modalTableData.fail_num ?modalTableData.fail_num :0}}
          </div>
        </div>
        <!-- 弹窗-表格
          ID
          用户ID
          企业名称
          体系
          文件下载链接
          文件处理数据数量详情
          状态 {1: 已导入, 2: 有错误, 3: 文件错误, 4: 待导入, 5:正在导入}
          导入时间
          完成时间
         -->
        <md-table v-model="modalTableData.records" class="left-table center-table">
          <md-table-row slot="md-table-row" slot-scope="{item}">
            <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
            <md-table-cell :md-label="$I18n('cdk')">{{ item.cdk }}</md-table-cell>
            <md-table-cell :md-label="'UID'">{{ item.uid }}</md-table-cell>
            <md-table-cell :md-label="$I18n('channel')">{{ item.ch_no }}</md-table-cell>
            <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
          </md-table-row>
          <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
        </md-table>
        <!-- 弹窗-翻页 -->
        <table-page :total="import_total" :pageSize="import_pageSize" v-model="import_currentPage"/>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { CdkCard } from "@/components";
import { IconCdk, IconChannel, IconAppid, IconAccount, IconUid,IconReset } from "@/components/IconSvg";

export default {
  components: {
    CdkCard,
    IconCdk,
    IconChannel,
    IconAppid,
    IconAccount,
    IconUid,
    IconReset,
  },
  created(){
    document.getElementsByTagName("title")[0].text = "增值服务套餐激活"
  },
  watch:{
    import_currentPage(){
      this.api_getXlsxData();
    },
  },
  data() {
    return {
      modalInitTableData:{
        "state": 1,
        "app_id": "",
        "start_type": 1,
        "file_url": "",
        "mng_num": 0,
        "suc_num": 0,
        "fail_num":0,
        "records": [],
      },
      form_id : "",
      import_id: "",
      import_total:0,
      import_pageSize    : 10,
      import_currentPage : 1,
      file_name:"",
      file_url:"",
      active_type:1,
      uid : "",
      channel : "",
      account : "",
      appid : "",
      cdk : "",
      start_type:1,
    };
  },
  computed:{
    modalTableData(){
      let state_name      = "";
      let start_type_name = "";
      const {state, start_type} = this.modalInitTableData;

      if(state == 1){
        state_name = "导入全部成功"
      } else if(state == 2){
        state_name = "导入有部分失败"
      } else if(state == 3){
        state_name = "文件有问题,完全无法导入"
      } else if(state == 4){
        state_name = "待导入"
      }

      if(start_type == 1){
        start_type_name = "立即生效"
      } else if(start_type == 2){
        start_type_name = "顺延生效"
      }

      return {
        ...this.modalInitTableData,
        state_name,
        start_type_name,
        records: !this.modalInitTableData.records ?[] :this.modalInitTableData.records.map(item => {
          let sub_state_name = "";
          if(item.state == 1){
            sub_state_name = "待处理"
          } else if(item.state == 2){
            sub_state_name = "成功"
          } else if(item.state == 3){
            sub_state_name = "失败"
          }
          return {
            ...item,
            state_name : sub_state_name,
          }
        })
      }
    },
  },
  methods: {
    modal_changeSearchData(){
      this.import_id = this.form_id;
      this.import_currentPage = 1;
      this.api_getXlsxData();
    },
    api_getXlsxData (){ // API-提交xls文件数据
      this.$api.getCdkUse({
        id: this.import_id,
        page_size: this.import_pageSize,
        page_no: this.import_currentPage,
      }) 
        .then(this.$Then(resData => {
          if(resData.code == 400){
            this.$errorMsg("导入ID错误");
            return
          }
          this.modalInitTableData = resData.data;
          this.import_total = resData.count;
        }), [400])
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.import_total = 0;
          this.modalInitTableData = {
            "state": 1,
            "app_id": "",
            "start_type": 1,
            "file_url": "",
            "mng_num": 0,
            "suc_num": 0,
            "fail_num":0,
            "records": [],
            state_name:"",
            start_type_name:"",
          };
        }))
    },
    form_importTableModel () { // 表单-打开导入弹窗
      if(this.import_id){
        this.api_getXlsxData();
      }
      this.$refs.import.open();
    },
    // (file发生变化)
    onChange ($event) {
      this.onFileSelected($event)
    },
    //点击上传文件
    modal_file_input(){
      this.$refs.inputFile.click()
    },
    onFileSelected ({ target, dataTransfer }) {
      const files = target.files || dataTransfer.files;

      this.file_name = this.getFileName(files, target);
    },
    getFileName (files, target) {
      if (!files || files.length === 0) {
        return target.value.split('\\').pop()
      }

      if (files.length > 1) {
        return this.getMultipleName(files)
      }

      if (files.length === 1) {
        var formData = new FormData();
        formData.append('myfile', files[0]);
        this.$api.uploadFile(formData)
          .then(this.$Then(res => {
            this.file_url = res.data
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
        return files[0].name
      }
      return null
    },
    submit (){
      if(this.active_type == 2){
        this.$api.actCode({
          "app_id"    : this.appid.replace(/(^\s+)|(\s+$)/g, ""),
          "file_url"  : this.file_url,
          "start_type": this.start_type,
        })
          .then(this.$Then(res => {
            this.$successMsg(this.$I18n("import_success_id") + res.data.id, 5000)
            this.form_id = String(res.data.id)
            this.import_id = String(res.data.id)
          }))
          .catch(err => {
            console.error(err)
            if(err.code == 1008){
              this.$errorMsg(this.$I18n("used_code"))
            } else if(err.code == 1009){
              this.$errorMsg(this.$I18n("old_code"))
            } else if(err.code == 1010){
              this.$errorMsg(this.$I18n("error_code_1010"))
            } else if(err.code == 10010){
              this.$errorMsg(this.$I18n("cant_use_code"))
            } else if(err.code == 10){
              this.$errorMsg(this.$I18n("none_code"))
            } else {
              this.$errorMsg(this.$I18n("get_error"))
            }
          })
        return
      }
      if(isNaN(this.channel) || this.channel <= 0){
        this.$errorMsg("通道必须填大于0的数(小数部分自动省略)")
        return
      }
      this.$api.getActCode({
        app_id: this.appid,
        cdk   : this.cdk,
        page_no  : 1,
        page_size: 10,
      })
        .then(this.$Then(codeRes => {
          if(codeRes.data.length < 1){
            throw new Error(10)
          }
          return this.$api.actCode({
            "uid"       : this.uid.replace(/(^\s+)|(\s+$)/g, ""),
            "channel"   : this.channel.replace(/(^\s+)|(\s+$)/g, ""),
            "user_id"   : this.account.replace(/(^\s+)|(\s+$)/g, ""),
            "app_id"    : this.appid.replace(/(^\s+)|(\s+$)/g, ""),
            "cdk"       : this.cdk.replace(/(^\s+)|(\s+$)/g, ""),
            "start_type": this.start_type,
          })
        }))
        .then(this.$Then(() => {
          this.$successMsg("激活成功")
        }))
        .catch(err => {
          console.error(err)
          if(err.code == 1008){
            this.$errorMsg(this.$I18n("used_code"))
          } else if(err.code == 1009){
            this.$errorMsg(this.$I18n("old_code"))
          } else if(err.code == 1010){
            this.$errorMsg(this.$I18n("error_code_1010"))
          } else if(err.code == 10010){
            this.$errorMsg(this.$I18n("cant_use_code"))
          } else if(err.code == 10){
            this.$errorMsg(this.$I18n("none_code"))
          } else {
            this.$errorMsg(this.$I18n("get_error"))
          }
        })
    },
    reset(){
      this.uid = "";
      this.channel = "";
      this.account = "";
      this.appid = "";
      this.cdk = "";
    },
  },
};
</script>

<style type="scss" scoped>
  .diy-submit{
    width: 90%;
  }
  .md-form-group{
    margin-top: 30px;
    margin-bottom: 20px;
  }
</style>
